import ajax from "./ajax";

export function getCategory() {
  return ajax(`/categories?CategoriesSearch[parent_category]=2&sort=display_order`);
}
